@if (customers$ | async; as customers) {
  @if (!!customers?.length) {
    <ul class="navbar-nav">
      <li class="nav-item d-flex align-items-center py-2 px-3">
        @if (customers?.length === 1) {
          <span class="text-white text-nowrap">{{ customers[0].description }}</span>
        } @else {
          <select
            class="form-select form-select-sm"
            [(ngModel)]="customerSelectService.currentCustomer"
            [ngModelOptions]="{ standalone: true }"
            (change)="setCustomer($event)"
          >
            @for (customer of customers$ | async; track customer.id) {
              <option value="{{ customer.id }}" [selected]="customerSelectService.currentCustomer === customer.id">
                {{ customer.description }}
              </option>
            }
          </select>
        }
      </li>
    </ul>
  }
}
